export interface LocationDto {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  stateCode?: string;
}
